import {
  FETCH_LABEL, FETCH_LABEL_SUCCESS, FETCH_LABEL_FAILURE,
  FETCH_NEW_LABEL, FETCH_NEW_LABEL_SUCCESS, FETCH_NEW_LABEL_FAILURE,
} from '../actions/label';

const INITIAL_STATE = { loading: true, labelById: {} };

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_LABEL:
      return { ...state, loading: true };
    case FETCH_LABEL_SUCCESS:
      return {
        ...state,
        labelById: {
          ...state.labelById,
          ...action.payload,
        },
        loading: false,
        error: null,
      };
    case FETCH_LABEL_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case FETCH_NEW_LABEL:
      return { ...state, newLabelLoading: true };
    case FETCH_NEW_LABEL_SUCCESS:
      return {
        ...state,
        returns: state.returns.map((returnItem) => {
          if (action.payload.returnId === returnItem.returnOrderId) {
            return Object.assign({}, returnItem, {
              returnInitiation: Object.assign({}, returnItem.returnInitiation, {
                shippingLabels: [].concat(returnItem.returnInitiation.shippingLabels, [
                  Object.assign({}, action.payload.label, {
                    packageStatus: 'Pending',
                  }),
                ]),
              }),
            });
          }

          return returnItem;
        }),
        newLabelLoading: false,
        newLabelError: null,
      };
    case FETCH_NEW_LABEL_FAILURE:
      return { ...state, newLabelLoading: false, newLabelError: action.payload };
    default:
      return state;
  }
}
